/* eslint-disable no-nested-ternary */
import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectAllFormSettings } from "../redux/slices/formSettingsSlice";
import { selectCurrentPage } from "../redux/slices/currentPageSlice";
import P2PInjection from "./P2PInjection";

const ConnectedP2PInjection = ({ dataLocation }) => {
    // logic for this component comes from getInjectionData in redux/reducers
    const formSettings = useSelector(selectAllFormSettings);
    const {
        theme: { add_header = "", add_footer = "", pageSpecificSettings },
    } = formSettings;

    const currentPage = useSelector(selectCurrentPage);

    const pageSpecificContent =
        currentPage &&
        pageSpecificSettings &&
        Object.keys(pageSpecificSettings[currentPage]).length > 0
            ? pageSpecificSettings[currentPage]
            : {};

    const pageHeader = pageSpecificContent.add_header;

    const headerContent = pageHeader ? add_header + pageHeader : add_header;

    const pageFooter = pageSpecificContent.add_footer;

    const footerContent = pageFooter ? add_footer + pageFooter : add_footer;

    const injectionData =
        dataLocation === "header"
            ? headerContent
            : dataLocation === "footer"
              ? footerContent
              : null;

    return <P2PInjection injectionData={injectionData} />;
};

ConnectedP2PInjection.propTypes = {
    dataLocation: PropTypes.string.isRequired,
};

export default ConnectedP2PInjection;
